import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { withFormik } from "formik"
import { InputNumber } from "primereact/inputnumber"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"

const DiasPago = ({
  handleSubmit,
  values,
  setFieldValue,
  onHide,
  isValid,
}: {
  handleSubmit: () => void
  values: { diasPago: number }
  setFieldValue: (
    field: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: $TSMigrationFixMe,
    shouldValidate?: boolean
  ) => Promise<void>
  onHide: () => void
  isValid: boolean
}) => {
  const { t } = useTranslation()
  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='diasPago'>
            {t("crear.facturaRec.modal.paymentDayLabel")}
          </label>

          <InputNumber
            autoFocus
            id='diasPago'
            name='diasPago'
            min={0}
            value={values.diasPago}
            onChange={(e) => setFieldValue("diasPago", e.value)}
          />
        </div>
      </div>

      <div className='tw-mt-4 tw-flex tw-h-10 tw-flex-row tw-justify-end tw-items-center'>
        <ButtonPrimeReact
          className='tw-mr-3 tw-h-10 tw-flex tw-justify-center tw-items-center !tw-text-text !tw-border-none !tw-bg-transparent tw-cursor-pointer hover:!tw-shadow'
          onClick={onHide}
        >
          {t("crear.facturaRec.modal.cancelButton")}
        </ButtonPrimeReact>
        <ButtonPrimeReact
          type='submit'
          disabled={!isValid}
          className='!tw-bg-primary tw-h-10 tw-flex tw-justify-center tw-items-center hover:!tw-shadow hover:!tw-bg-primary-over'
        >
          {t("crear.facturaRec.modal.addButton")}
        </ButtonPrimeReact>
      </div>
    </form>
  )
}

const validate = Yup.object().shape({
  diasPago: Yup.number().min(0).required(),
})

const FormDiasPagoDocumento = withFormik({
  validationSchema: validate,
  validateOnMount: true,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mapPropsToValues: ({ diasPago }: $TSMigrationFixMe) => ({
    diasPago: diasPago || 0,
  }),
  handleSubmit: ({ diasPago }, { props }) => {
    props.onChange(diasPago)
    props.onHide()
  },
})(DiasPago)

export default FormDiasPagoDocumento
